import { DebitNote } from '../../types';

export interface DebitNoteTemplateContext {
  clientName?: string;
  clientAddress?: string;
  invoiceId: string;
  vesselName?: string;
}

export const generateEnglishTemplate = (
  notes: DebitNote[],
  ctx: DebitNoteTemplateContext
): string => {
  const totalUSD = notes.reduce((sum, note) => sum + note.netRemaining.usd, 0);
  const totalEGP = notes.reduce((sum, note) => sum + note.netRemaining.egp, 0);

  return `
<!DOCTYPE html>
<html>
<head>
    <meta charset="UTF-8">
    <title>Debit Note Payment Request</title>
    <style>
        @page { margin: 20mm; size: A4; }
        body { font-family: 'Arial', sans-serif; font-size: 12px; line-height: 1.6; margin: 0; padding: 0; color: #000; }
        .header { text-align: center; margin-bottom: 30px; border-bottom: 2px solid #000; padding-bottom: 15px; }
        .company-name { font-size: 18px; font-weight: bold; color: #000; margin-bottom: 5px; }
        .date-section { text-align: right; margin: 20px 0; font-weight: bold; }
        .recipient-section { margin: 20px 0; padding: 15px; border: 1px solid #000; background-color: #f9f9f9; }
        .subject-line { margin: 20px 0; font-weight: bold; font-size: 14px; text-decoration: underline; }
        .content-section { margin: 20px 0; text-align: justify; }
        .debit-notes-section { margin: 20px 0; padding: 15px; border: 1px solid #000; background-color: #f5f5f5; }
        .debit-notes-title { font-weight: bold; margin-bottom: 15px; font-size: 14px; text-decoration: underline; }
        .debit-note-item { margin: 10px 0; padding: 10px; background-color: white; border-left: 3px solid #007acc; }
        .note-number { font-weight: bold; color: #007acc; }
        .note-details { margin-left: 20px; }
        .total-section { margin: 20px 0; padding: 15px; border: 2px solid #000; background-color: #e0e0e0; text-align: center; }
        .total-amount { font-size: 16px; font-weight: bold; color: #d00; }
        .signature-section { margin-top: 50px; text-align: center; }
        .signature-line { border-bottom: 1px solid #000; margin: 30px auto 10px auto; width: 200px; }
        .footer { margin-top: 40px; text-align: center; border-top: 1px solid #000; padding-top: 15px; font-size: 10px; background-color: #f9f9f9; }
        @media print { .no-print { display: none !important; } }
    </style>
</head>
<body>
    <div class="header">
        <div class="company-name">Petromarine Offshore Projects Support Co.</div>
        <div style="font-size: 12px; color: #666;">شركة بتروماري للمشاريع البحرية</div>
    </div>
    <div class="date-section">
        Date: ${new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
    </div>
    <div class="recipient-section">
        <div><strong>TO:</strong> ${ctx.clientName || '[Client Name]'}</div>
        <div style="margin-top: 5px; padding-left: 30px;">${ctx.clientAddress || '[Client Address]'}</div>
    </div>
    <div class="subject-line">Subject: Debit Note Payment Request</div>
    <div class="content-section">
        <p><strong>Dear Sir/Madam,</strong></p>
        <p>We hope this letter finds you in good health.</p>
        <p>We would like to inform you that there are outstanding debit notes related to <strong>Invoice #${ctx.invoiceId}</strong> for vessel <strong>${ctx.vesselName || '[Vessel Name]'}</strong> that require your immediate attention.</p>
    </div>
    <div class="debit-notes-section">
        <div class="debit-notes-title">Debit Note Details:</div>
        ${notes.map((note, index) => `
            <div class="debit-note-item">
                <div class="note-number">${index + 1}. Date: ${note.date}</div>
                <div class="note-details">
                    <div><strong>Description:</strong> ${note.description}</div>
                    <div><strong>Amount:</strong> $${note.netRemaining.usd.toFixed(2)} USD / ${note.netRemaining.egp.toFixed(2)} EGP</div>
                </div>
            </div>
        `).join('')}
    </div>
    <div class="total-section">
        <div class="total-amount">Total Outstanding Amount: $${totalUSD.toFixed(2)} USD / ${totalEGP.toFixed(2)} EGP</div>
    </div>
    <div class="content-section">
        <p>We kindly request that you settle the above outstanding amounts at your earliest convenience. Please note that these amounts are due for payment as per our agreed terms.</p>
        <p>Should you have any questions or require additional documentation, please do not hesitate to contact us.</p>
        <p>Thank you for your cooperation and prompt attention to this matter.</p>
    </div>
    <div class="signature-section">
        <p><strong>Best regards,</strong></p>
        <div class="signature-line"></div>
        <div><strong>General Manager</strong></div>
        <div><strong>Petromarine Offshore Projects Support Co.</strong></div>
    </div>
    <div class="footer">
        <div><strong>Address:</strong> Office No. 101, Building No. 3, Street No. 983, Salwa Road, Alexandria, Egypt</div>
        <div><strong>Tel:</strong> +20 1 069 069 300 | <strong>Fax:</strong> +20 3 569 5300</div>
        <div><strong>E-mail:</strong> operations@petromarine.net | <strong>Website:</strong> www.petromarine.net</div>
    </div>
</body>
</html>`;
};

